import { States } from "..";

export function getGraphWidth(states: States) {
   return states.chart.graphWidth;
}

export function getGraphHeight(states: States) {
   return states.chart.graphHeight;
}

